import { Component, OnInit, inject, DOCUMENT } from '@angular/core';
import { FormControl, Validators } from '@angular/forms';
import { StoreDetail } from '../../models/store-details.model';
import { StoreDetailService } from '../../services/resolver/store-detail.service';

import { NavigationEnd, Router, RouterLink } from '@angular/router';
import { Icons } from '../../enum/icons';
import { StoreRegionService } from '../../services/store-region.service';

const FOOTER_STATIC_PAGES = [
  'return-policy',
  'cookie-policy',
  'privacy-policy'
];
@Component({
    selector: 'app-footer',
    templateUrl: './footer.component.html',
    styleUrls: ['./footer.component.scss'],
    standalone: true,
    imports: [RouterLink]
})
export class FooterComponent implements OnInit {
  private storeDetailResolver = inject(StoreDetailService);
  private router = inject(Router);
  private document = inject<Document>(DOCUMENT);
  private storeRegionService = inject(StoreRegionService);

  icons = Icons;
  storeDetail: StoreDetail;
  copyrightTitle: string;
  copyrightUrl: string;
  emailField = new FormControl('', [Validators.email, Validators.required]);
  staticPages;
  hideNavigation: boolean = false;
  isLightMode: boolean = true;
  countryCode: string = '';
  constructor() {
    this.hideNavigation = this.isNoneNavigationRoute;
    this.router.events.subscribe((event) => {
      if (event instanceof NavigationEnd) {
        this.hideNavigation = this.isNoneNavigationRoute;
      }
    });
  }

  ngOnInit(): void {
    this.countryCode = this.storeRegionService.selectedRegion?.code;
    this.getStoreDetail();
  }

  onSubmitEmail() {}

  getStoreDetail() {
    this.storeDetail = this.storeDetailResolver?.permissionInit;
    this.staticPages = this.storeDetail?.static_pages?.filter((obj) =>
      FOOTER_STATIC_PAGES.some((str) => obj.slug === str)
    );
    this.copyrightTitle =
      this.storeDetailResolver?.permissionInit?.copyright_title;
    this.copyrightUrl = this.storeDetailResolver?.permissionInit?.copyright_url;
  }

  scrollToTop() {
    this.document.getElementById('mainPage').scrollIntoView({
      behavior: 'smooth'
    });
  }

  private get isNoneNavigationRoute() {
    return this.router.url.includes('/authenticate');
  }
}
